export default __webpack_public_path__ + "static/SRUS P330 - Product Specifications & Technical Data-5d1e0c00314cd8ef8ee02c997e921f26.pdf";